<template>
  <v-form v-model="valid" ref="mainForm">
    <CaseACocherLive
      code="optout_maestro"
      :disabled="estMidiScientifique"
      ref="optOutMaestro"
      :live="liveSasAccreditation(24605)"
      v-model="sasAccreditation.optOutMaestro"
    />
    <DatePickerLive
      code="date_debut_affichage"
      :opqIf="!sasAccreditation.optOutMaestro"
      v-model="sasAccreditation.dateDebutDAffichage"
      :live="liveSasAccreditation(24643)"
      :minValue="sas.serverDateTime"
    />
    <DatePickerLive
      code="date_fin_affichage"
      :opqIf="!sasAccreditation.optOutMaestro"
      v-model="sasAccreditation.dateFinDAffichage"
      :live="liveSasAccreditation(24644)"
      :minValue="sasAccreditation.dateDebutDAffichage"
      :maxValue="serverDatePlusNMonths(13)"
    />

    <MemoLive
      code="description_formation"
      :opqIf="!sasAccreditation.optOutMaestro"
      v-model="sasAccreditation.descriptionLongue"
      :live="liveSasAccreditation(24646)"
    />

    <TextFieldLive
      code="mots-cles"
      :opqIf="!sasAccreditation.optOutMaestro"
      v-model="sasAccreditation.motsCles"
      :live="liveSasAccreditation(24647)"
    />

    <CatalogueLive
      code="mode_diffusion"
      :opqIf="!sasAccreditation.optOutMaestro"
      v-model="sasAccreditation.modeDeDiffusion"
      :live="liveSasAccreditation(24648)"
    />

    <MemoLive
      code="exigences_restrictions_prerequis"
      :opqIf="!sasAccreditation.optOutMaestro"
      v-model="sasAccreditation.exigencesRestrictionsEtPrerequisInscription"
      :live="liveSasAccreditation(24649)"
    />

    <TextFieldLive
      code="contact_prenomnom"
      :opqIf="!sasAccreditation.optOutMaestro"
      v-model="sasAccreditation.prenomNomDeLaPersonneRessource"
      :live="liveSasAccreditation(24650)"
    />

    <TextFieldLive
      code="contact_coordonnees"
      :opqIf="!sasAccreditation.optOutMaestro"
      v-model="sasAccreditation.coordonneesDeLaPersonneRessource"
      :live="liveSasAccreditation(24651)"
    />

    <TextFieldLive
      code="lien_inscription"
      :opqIf="!sasAccreditation.optOutMaestro"
      v-model="sasAccreditation.lienVersLaPlateformeDeFormationOuInscription"
      :live="liveSasAccreditation(24652)"
      :maxLength="500"
    />
  </v-form>
</template>

<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import infosGeneralesAccreditation from "@/components/Formulaires/DemandeAccreditation/mixins/infosGeneralesAccreditation"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers, infosGeneralesAccreditation],
  props: {
    sas: { type: Object }
  },
  watch: {
    "sas.sasAccreditation.formatDeFormation"(newValue) {
      if (this.getCatalogueCodeById(this.$constants.DESCID.ACCREDITATION.FORMAT, newValue) === this.$constants.CODE.FORMAT.MIDI_SCIENTIFIQUE) {
        this.$refs.optOutMaestro.setValue(true)
      }
    }
  }
}
</script>

<style></style>
